import { App } from 'vue';
import { can, hasRole } from '@/services/acl';

const permissionsDirective = {
  beforeMount(el: HTMLElement, binding: any) {
    const { value } = binding;

    // value should be an object like { permission: "createProduct", role: "admin" }
    if (typeof value === 'object') {
      const { permission, role } = value;
      if (!can(permission) && !hasRole(role)) {
        el.style.display = 'none'; // Hide the element if the user doesn't have the permission/role
      }
    } else {
      // Simple permission check
      if (!can(value)) {
        el.style.display = 'none'; // Hide if permission is not found
      }
    }
  },
};

export function setupPermissionsDirective(app: App) {
  app.directive('permissions', permissionsDirective);
}
